import React from 'react';
import { Paper, Typography, Button, IconButton, Box, Slide } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import GetAppIcon from '@mui/icons-material/GetApp';
import { useTranslation } from 'react-i18next';
import { usePWAInstall } from '../../hooks/usePWAInstall';

export const InstallPromptBanner: React.FC = () => {
  const { t } = useTranslation();
  const { showInstallBanner, showIOSInstructions, promptInstall, dismissBanner } = usePWAInstall();

  if (!showInstallBanner) return null;

  return (
    <Slide direction="up" in={showInstallBanner}>
      <Paper
        elevation={8}
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          p: 2,
          zIndex: 1300,
          borderRadius: '16px 16px 0 0',
          display: 'flex',
          flexDirection: 'column',
          gap: 1.5,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
          <Box
            component="img"
            src="/logo192.png"
            alt="Mowilex"
            sx={{ width: 48, height: 48, borderRadius: 1, flexShrink: 0 }}
          />
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="subtitle1" fontWeight={600}>
              {t('pwa.installTitle')}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {showIOSInstructions
                ? t('pwa.iosInstructions')
                : t('pwa.installSubtitle')}
            </Typography>
            {showIOSInstructions && (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                {t('pwa.iosInstructions2')}
              </Typography>
            )}
          </Box>
          <IconButton size="small" onClick={dismissBanner} aria-label="close">
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
        {!showIOSInstructions && (
          <Button
            variant="contained"
            startIcon={<GetAppIcon />}
            onClick={promptInstall}
            fullWidth
            sx={{ borderRadius: 2 }}
          >
            {t('pwa.installButton')}
          </Button>
        )}
      </Paper>
    </Slide>
  );
};
